import { render } from "./collectCenter.vue?vue&type=template&id=10fcd1fa&scoped=true"
import script from "./collectCenter.vue?vue&type=script&lang=js"
export * from "./collectCenter.vue?vue&type=script&lang=js"

import "./collectCenter.vue?vue&type=style&index=0&id=10fcd1fa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fcd1fa"]])

export default __exports__